module.exports = __webpack_public_path__ + "static/media/sellcast.ea64b3d9.svg";